export default "__VITE_ASSET__e9c38706__"